import React from 'react';
import { FlameIcon } from 'lucide-react';
import { SPOTS_LEFT, SPOTS_TOTAL } from '../config';
export function ScarcityBar() {
  const taken = SPOTS_TOTAL - SPOTS_LEFT;
  const pct = Math.round(taken / SPOTS_TOTAL * 100);
  return <div className="mx-auto w-full max-w-md rounded-2xl border-2 border-brand-orange/30 bg-orange-50 p-4" data-id="element-172">
      <div className="mb-2 flex items-center justify-between gap-2" data-id="element-173">
        <span className="flex items-center gap-1.5 text-sm font-extrabold text-brand-orange" data-id="element-174">
          <FlameIcon className="h-4 w-4" data-id="element-175" />
          ¡Últimos cupos!
        </span>
        <span className="text-sm font-bold text-brand-purpleDark" data-id="element-176">
          Quedan {SPOTS_LEFT} de {SPOTS_TOTAL}
        </span>
      </div>
      <div className="h-4 w-full overflow-hidden rounded-full bg-orange-200" data-id="element-177">
        <div className="flex h-full items-center justify-end rounded-full bg-gradient-to-r from-brand-orange to-brand-pink pr-2" style={{
        width: `${pct}%`
      }} data-id="element-178">
          <span className="text-[9px] font-black text-white" data-id="element-179">{pct}%</span>
        </div>
      </div>
      <p className="mt-2 text-center text-xs font-semibold text-brand-purpleDark/70" data-id="element-180">
        Al agotarse los cupos, el precio promocional desaparece.
      </p>
    </div>;
}